<template v-if="message">
  <div class="mt-2 text-red-600">
    {{ message }}
  </div>
</template>

<script setup lang="ts">
defineProps<{
  message?: string
}>()
</script>
